import { render, staticRenderFns } from "./editPw.vue?vue&type=template&id=c6e1824e&scoped=true"
import script from "./editPw.vue?vue&type=script&lang=js"
export * from "./editPw.vue?vue&type=script&lang=js"
import style0 from "./editPw.vue?vue&type=style&index=0&id=c6e1824e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e1824e",
  null
  
)

export default component.exports